import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './i18n';
import { BrowserRouter } from 'react-router-dom';

// styles
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
